import type { TimelineEvent } from "@productlane/api/src/browser"

export const MIN_FOLDED_RUN_LENGTH = 4

export const isMilestoneEvent = (event: TimelineEvent): boolean =>
	event.type === "activity" && event.threadActivity.eventType === "pr_merged"

export type ActivityRunRow =
	| { kind: "event"; event: TimelineEvent; index: number }
	| { kind: "toggle"; hidden: TimelineEvent[] }

// Milestones and the newest event stay visible; the toggle sits where the first
// hidden event would, so it keeps its spot when the run expands.
export function buildActivityRunRows(
	events: TimelineEvent[],
	expanded: boolean,
): ActivityRunRow[] {
	const lastIndex = events.length - 1
	const hiddenIndexes = new Set(
		events.flatMap((event, index) =>
			index !== lastIndex && !isMilestoneEvent(event) ? [index] : [],
		),
	)
	const toEventRow = (event: TimelineEvent, index: number): ActivityRunRow => ({
		kind: "event",
		event,
		index,
	})

	if (hiddenIndexes.size < 2) return events.map(toEventRow)

	const hidden = events.filter((_, index) => hiddenIndexes.has(index))
	const firstHiddenIndex = Math.min(...hiddenIndexes)
	const rows: ActivityRunRow[] = []
	events.forEach((event, index) => {
		if (index === firstHiddenIndex) rows.push({ kind: "toggle", hidden })
		if (expanded || !hiddenIndexes.has(index))
			rows.push(toEventRow(event, index))
	})
	return rows
}
